import React from 'react';
import SocialLinks from './common/SocialLinks';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-8 px-4 mt-12">
      <div className="container mx-auto max-w-4xl">
        
        {/* CEVSOC Affiliation Section */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="text-center">
              <div className="text-xl font-semibold text-green-400"> 🤝 Proudly Affiliated With CEVSOC 💚</div>
              <div className="text-sm text-gray-400">The Civil & Environmental Engineering Society UNSW</div>
            </div>
            <img 
              src="/images/cevsoc_logo.avif" 
              alt="CEVSOC Logo" 
              className="w-16 h-16 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline-block';
              }}
            />
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-3 text-center text-gray-400">⚠️ Important Disclaimer</h3>
          <div className="bg-gray-700 p-4 rounded-lg text-sm leading-relaxed">
            <p className="mb-3">
              <strong>Recommendations Only:</strong> This resume analysis tool provides suggestions and recommendations only. 
              All feedback is generated by proprietary algorithms and should be considered as guidance rather than definitive advice.
            </p>
            <p className="mb-3">
              <strong>No Guarantee of Accuracy:</strong> While we strive for accuracy, inaccuracies may occur in the analysis. 
              We recommend using this tool as one of many resources in your job search and resume improvement process.
            </p>
            <p className="mb-3">
              <strong>Industry Focus:</strong> Some analysis features and keyword matching are specifically tailoured 
              towards civil engineering and related technical fields. Results may be less relevant for other industries.
            </p>
            <p>
              <strong>Professional Review:</strong> For important applications, we recommend having your resume 
              reviewed by a professional career adviser or industry expert.
            </p>
          </div>
        </div>


        {/* Social Links Section */}
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-400">🔗 Got Feedback or Questions? Connect With Me</h3>
          <SocialLinks 
            layout="horizontal"
            size="medium"
            showLabels={true}
            className="justify-center"
          />
        </div>
        {/* Divider */}
        <div className="border-t border-gray-600 my-6"></div>

        {/* Copyright and Links */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <div className="mb-4 md:mb-0">
            <p>&copy; {currentYear} Lachlan Ho. All rights reserved.</p>
          </div>
          
          <div className="flex space-x-6">
            <span className="hover:text-white transition-colors cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white transition-colors cursor-pointer">Terms of Service</span>
            <span className="hover:text-white transition-colors cursor-pointer">Contact</span>
          </div>
        </div>
      </div>

      
    </footer>
  );
};
       

export default Footer; 